import React from 'react';
import { GlobalDesignActionLobbyItem } from '../../types';

const defaultLobbyItem: GlobalDesignActionLobbyItem = () => {
  // Do adapter between group and components unbounded lobby item
  return <>{}</>;
};

export default defaultLobbyItem;
